// CardContent.tsx
import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const Title = styled.div`
  font-size: 16px;
  font-weight: 500;
  line-height: 30px;
           @media (max-width: 768px) {
    font-size: 14px; 
  }
  color: var(--text-secondary-color);
`;

const ValueRow = styled.div`
  display: flex;
  align-items: baseline;
  gap: 4px;
`;

const Prefix = styled.span`
  font-size: 22px;

  color: var(--text-secondary-color); /* цвет префикса, например $ */
`;

const Value = styled.span`
  font-size: 22px;
  font-weight: 500;
  line-height: 30px;
  color: var(--text-color);

`;

const SubValue = styled.span`
  font-size: 16px;
  color: var(--text-active-color); /* цвет прироста */
  margin-left: 4px;
`;

interface CardContentProps {
  title: string;
  value: string | number;
  prefix?: string;       // например $
  subValue?: string | number; // прирост, маленький текст снизу
}

export const CardContent: React.FC<CardContentProps> = ({ title, value, prefix, subValue }) => (
  <Container>
    <Title>{title}</Title>
    <ValueRow>
      {prefix && <Prefix>{prefix}</Prefix>}
      <Value>{value}</Value>
          {subValue && <SubValue>{subValue}</SubValue>}
    </ValueRow>

  </Container>
);
